export default __webpack_public_path__ + "static/media/donut-03.67c5b054.png";